<template>
  <div class="h-dialogContainer">
    <form id='addNeFF'>
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>         
           <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.neDev')}}:</div>
          <ejs-dropdownlist
            name="neDev"
            id='neDevDropdownlist'
            ref='ddlObj'
            :placeholder="neDevPlaceholder"
            :dataSource="neDev"
            v-model="neinfo.equipmentId"
            :fields="neDevFields"
            :change="onAttriDeviceChange"
            :readonly="readNeDev"
            :noRecordsTemplate="noRecordsTemplate"
             allowTextWrap='true' 
          ></ejs-dropdownlist>
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.neType')}}:</div>
          <ejs-dropdownlist
             name="neType"
             id='neTypeDropdownlist'
            :placeholder="neTypePlaceholder"
            :dataSource="typeData"
            v-model="neinfo.typeCode"
            :fields="typeFields"
            :change="onNeTypeChange"
            :readonly="readNeType"
            :noRecordsTemplate="noRecordsTemplate"
            :allowFiltering='true' 
            :filtering='onFiltering' 
            :filterBarPlaceholder="filterPlaceholder"
          ></ejs-dropdownlist>
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
        <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.neName')}}:</div>
          <input
            name="neName"
            class="e-input"
            :placeholder="neNamePlaceholder"
            type="text"
            v-model="neinfo.name"
          />
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.cummunicateIPPort')}}:</div>
          <ejs-dropdownlist
             name="equipmentIPId"
             id='equipmentIPIdDropdownlist'
            :placeholder="cummunicateIPPortPlaceholder"
            :dataSource="neIPPort"
            v-model="neinfo.equipmentIPId"
            :fields="ipPortFields"
            :noRecordsTemplate="noRecordsTemplate"
          ></ejs-dropdownlist>
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.physicalIP')}}:</div>
            <input
              name="neIP"
              class="e-input"
             :placeholder="neIPPlaceholder"
              v-model="neinfo.physicalIP"
            />
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.physicalPort')}}:</div>
          <input
            name="nePort"
            class="e-input"
            :placeholder="nePortPlaceholder"
            type="text"
            v-model="neinfo.physicalPort"
          />
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="h-col-inputBox-a">
        <div class="h-inputLit">{{this.$t('Topo.neDescription')}}:</div>
        <ejs-textbox  name="neDescription" :placeholder="neDescriptionPlaceholder" v-model="neinfo.description" multiline="true"></ejs-textbox>
      </div>
    </div>
    <div class="h-clear-rowMg"></div>
    </form>
  </div>
</template>

<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import { Query } from '@syncfusion/ej2-data';
import { EventBus } from '../../plugins/eventBus';
import { Tooltip } from '@syncfusion/ej2-popups';

export default {
  name: 'add-ne',
  data() {
    return {
      neNamePlaceholder: this.$t('Topo.neName'),
      neTypePlaceholder: this.$t('Topo.devAttriSelect'),
      neDevPlaceholder: this.$t('Topo.neDev'),
      neDescriptionPlaceholder: this.$t('Topo.neDescription'),
      neIPPlaceholder:this.$t('Topo.physicalIP'),
      nePortPlaceholder: this.$t('Topo.physicalPort'),
      cummunicateIPPortPlaceholder: this.$t('Topo.devAttriSelect'),
      noRecordsTemplate: this.$t('Topo.noData'),
      filterPlaceholder: this.$t('Topo.search'),
      neinfo: {
        id: '',
        name: '',
        typeCode: '',
        positionX: 225,
        positionY: 226,
        equipmentId:'',
        equipmentIPId: '',
        physicalIP: '',     
        physicalPort: '',
        description: ''
      },
      typeData: [], // 网元类型
      neDev: [], // 归属设备
      tooltip: Tooltip,
      neIPPort: [], // 通信IP和端口
      typeFields: { value: 'typeCode', text: 'nameKey' },
      neDevFields: { value: 'equipmentId', text: 'equipmentName' },
      ipPortFields: { value:'equipmentIPId', text: 'ipportIPPort' },
      readNeType: false,
      readNeDev:false,
      validationOption: {
        customPlacement(inputElement, errorElement) {
            errorElement.style.float = 'left';
            inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {                    
            neType: {                        
                required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            neName: {
                required: [true, `${this.$t('Pm.alertRequired')}`],
                regex: [/^(^\S)/, `${this.$t('Topo.noEmptyStart')}`],
                maxLength: [30, `${this.$t('Topo.topoMaxLength')}30`],
            },
            neDev: {                        
                required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            equipmentIPId: {                        
                required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            neIP: {                        
                required: [true, `${this.$t('Pm.alertRequired')}`],
                // maxLength: [255, `${this.$t('Pm.alertMaxLength')}255`],
                regex: [/^(25[0-5]|2[0-4]\d|[0-1]?\d?\d)(\.(25[0-5]|2[0-4]\d|[0-1]?\d?\d)){3}$/, `${this.$t('Topo.ipIllegal')}`]
            },
            nePort: {
              required: [true, `${this.$t('Pm.alertRequired')}`],
              regex: ['^\\d*$', `${this.$t('Topo.invalidInt')}`],
              range: [[1, 65535], `${this.$t('Topo.inputRangeIllegal')}`],
              //             regex: [/^(1(02[4-9]|0[3-9][0-9]|[1-9][0-9]{2})|[2-9][0-9]{3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/, `${this.$t('Topo.portIllegal')}`],
            },
            neDescription: {            
                maxLength: [255, `${this.$t('Topo.topoMaxLength')}255`],
            },
        }
    }, 
    };
  },
  mounted() {
    this.initData();
    this.bindValidate();
  },
  methods: {
    outputs(isFromGraph, positionX, positionY) {
      //表单验证
      if(!this.validate()){
          return;
      }
      if (isFromGraph) {
        this.neinfo.positionX = positionX;
        this.neinfo.positionY = positionY;
      }
      const params = {
        ...this.neinfo,
        typeCode: this.neinfo.typeCode.toString(),
      };
      this.axios.post('/lte/ems/topo/ne/addNe', params).then((response) => {
        console.log('addNe',response)
        if(response.data === undefined){
          return;
        }
        if (response.data.errorCode === 'SUCCESS') {
          EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
          this.closeWindow();
          return;
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
        this.closeWindow();
      });
    },


    // 新建网元时去后台查已经创建的设备
    queryAttriDevice(pId) {
      const This = this;
      This.$axios.get('/lte/ems/topo/ne/attriDevice').then(response => {  
        console.log('attriDevice',response)    
        if(response.data === undefined){
          return;
        }
        if( response.status ===200){
        if (response.data.errorCode === 'SUCCESS') {
          const neDevTemp=[];
          const len=response.data.resultVal.result.length;
          for(var i=0;i<len;i++){
            neDevTemp.push({
                equipmentId:response.data.resultVal.result[i].id,
                equipmentName:response.data.resultVal.result[i].name
              }) 
          }
          This.neDev = neDevTemp; 
          console.log('This.neDev',This.neDev)
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }  }
        if (pId) {
          this.neinfo.equipmentId = pId;
          this.readNeDev = true;
        }
      });
    },
    //切换归属设备时查能添加的网元类型
    onAttriDeviceChange(e) {       
      const attriDevId = parseInt(e.value);
      const This = this;
      const neTypeTemp=[];
      This.typeData = [];
      This.$axios.get(`/lte/ems/topo/ne/findNeType/${attriDevId}`).then(response => {
        if(response.data === undefined){
          return;
        }if( response.status ===200){
        if (response.data.errorCode === 'SUCCESS') {
         const neTypeTemp=[];
          const len=response.data.resultVal.length;
          for(var i=0;i<len;i++){    
            neTypeTemp.push({
                typeCode:response.data.resultVal[i].typeCode,
                nameKey:response.data.resultVal[i].nameKey
            }) 
          }
          This.typeData = neTypeTemp;  
        } else {
          This.typeData = [];
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }}
      });
     //查询归属设备的通信IP和端口
      this.findDevIpPort(e);
    },

    findDevIpPort(e) {
      const devID = parseInt(e.value);
      const This = this;
      const neIPPortTemp=[];
      This.$axios.get(`/lte/ems/topo/ne/findDevIpPort/${devID}`).then(response => {
        if(response.data === undefined){
          return;
        }
        if( response.status ===200){
        if (response.data.errorCode === 'SUCCESS') {
          const len=response.data.resultVal.length;
          for(var i=0;i<len;i++){
            neIPPortTemp.push({
                equipmentIPId:response.data.resultVal[i].id,
                ipportIPPort:response.data.resultVal[i].ip+':'+response.data.resultVal[i].port
              }) 
          }
          This.neIPPort = neIPPortTemp;
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        } }
      });
    },

    onNeTypeChange() {       
      const This = this;
      This.ipPortValue(this.neinfo.typeCode);
    }, 

    closeWindow() {
      console.log('close'); 
      this.$emit('close');
    },
    // 参数pId用于拓扑监控,请佩奇姐@小朱 注意资源管理不要对pId传参
    initData(nedata, pId) {
      // 新建设备专用
      console.log('addinitData')
      this.queryAttriDevice(pId);
      if (nedata == null) {
       console.log('nedata1', nedata);
        this.neinfo = {
          id: '',
          name: '',
          typeCode: '',
          equipmentId:'',
          equipmentIPId: '',
          physicalIP: '',     
          physicalPort: '',
          description: ''
        };
      }
    },

    bindValidate() {            
      this.formObj = new FormValidator('#addNeFF', this.validationOption);
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    },
    onFiltering(e){
      var query = new Query();
      query = (e.text !== '') ? query.where('nameKey', 'startswith', e.text, true) : query;
      e.updateData(this.typeData, query);
    },
    ipPortValue(typeCode){
    switch(typeCode)
      {   case 3:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '10400'
          break;
          case 4:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '10600'
          break;
          case 5:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '10200'
          break;
          case 6:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '10300'
          break;
          case 7:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '10700'
          break;
          case 8:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '11001'
          break;
          case 9:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '11002'
          break;
          case 10:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '11003'
          break;
          case 11:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '11004'
          break;
          case 12:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '12001'
          break;
          case 13:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '12005'
          break;
          case 14:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '12002'
          break;
          case 15:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '12000'
          break;
          case 16:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '12004'
          break;
          case 17:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '10800'
          break;
          case 18:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '10900'
          break;
          case 19:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '11006'
          break;
          case 20:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '12006'
          break;
          case 21:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '11005'
          break;
          case 23:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '11007'
          break;
          case 24:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '12003'
          break;
          case 27:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '15203'
          break;
          case 28:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '11008'
          break;
          case 31:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '11009'
          break;
          case 34:     
          this.neinfo.physicalIP = '127.0.0.1',     
          this.neinfo.physicalPort = '10021'
          break;
          // case 1000:   待定的网元
          // this.neinfo.physicalIP = '127.0.0.1',     
          // this.neinfo.physicalPort = '10900'
          // break;
          // case 1001:     
          // this.neinfo.physicalIP = '127.0.0.1',     
          // this.neinfo.physicalPort = '10900'
          // break;
          // case 1101:     
          // this.neinfo.physicalIP = '127.0.0.1',     
          // this.neinfo.physicalPort = '10900'
          // break;
       default:
          this.neinfo.physicalIP = '',     
          this.neinfo.physicalPort = ''
      }
    },

    // onCloseAAAAA(e) {
    //    console.log('onClose')
    //       this.tooltip.close();
    // },
    // onBeforeRender : function(args) {
    //     var result =  this.neDev;
    //     var i;
    //     for (i = 0; i < result.length; i++) {
    //         if (result[i].equipmentName === args.target.textContent) {
    //             this.tooltip.content = result[i].equipmentName;
    //             this.tooltip.dataBind();
    //             break;
    //         }
    //     }
    // },
    // onDropdownCreateAAAA(args) {
    //   console.log('onDropdownCreate')
    //     this.tooltip = new Tooltip({
    //     // default content of tooltip
    //         content: 'Loading...',
    //         // set target element to tooltip
    //         target: '.e-list-item',
    //         // set position of tooltip
    //         position: 'top center',
    //         // bind beforeRender event
    //         beforeRender: this.onBeforeRender
    //     });
    //     this.tooltip.appendTo('body');
    // } 
  }
};
</script>
